module.exports = __webpack_public_path__ + "static/media/payment-guide-step-2.f70998af.png";